import {
	StyleSheet,
	View,
	ScrollView,
	Text,
	TouchableOpacity,
	SafeAreaView,
	Pressable,
	FlatList,
	Modal,
} from "react-native";
import React from "react";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { getPrimaryColor } from "../../../utils/ColorsFunctions";
import { Ionicons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { useTheme } from "react-native-paper";

const DiscountsHeader = () => {
	const navigation = useNavigation();
	//const user = useAppSelector(s => s.auth.subUser!);
	const { colors } = useTheme();

	// const [selectedCategory, setSelectedCategory] = React.useState("Todos");

	// const staticCategories = [
	// 	{ name: "Todos", hasSubCategories: false },
	// 	{
	// 		name: "Carteira",
	// 		hasSubCategories: true,
	// 		subCategories: [
	// 			"Mostrar somente ISIC",
	// 			"Mostrar somente ITIC",
	// 			"Mostrar somente IYTC",
	// 			"Mostrar todos os descontos",
	// 		],
	// 	},
	// 	{
	// 		name: "Região",
	// 		hasSubCategories: true,
	// 		subCategories: ["Nacional", "Internacinal", "todos"],
	// 	},
	// 	{ name: "Cultura", hasSubCategories: false },
	// 	{ name: "Alimentação", hasSubCategories: false },
	// 	{ name: "Eletrônicos", hasSubCategories: false },
	// 	{ name: "Cursos e EAD", hasSubCategories: false },
	// 	{ name: "Entretenimento", hasSubCategories: false },
	// ];

	// const OverlayContainer = props => {
	// 	console.log({ props });
	// 	return (
	// 		<View style={styles.container2}>
	// 			{props.children.map((child, index) => (
	// 				<View style={styles.child} key={index}>
	// 					{child}
	// 				</View>
	// 			))}
	// 		</View>
	// 	);
	// };

	return (
		<SafeAreaView style={styles.root}>
			<TouchableOpacity
				style={[
					styles.pressable,
					{ backgroundColor: colors.figmaBackgroundColor },
				]}
				onPress={navigation.goBack}
			>
				<Ionicons name="chevron-back" size={24} color={colors.pureWhite} />
				<View style={styles.title}>
					<Text style={[styles.text, { color: colors.pureWhite }]}>
						Descontos
					</Text>
				</View>
			</TouchableOpacity>
		</SafeAreaView>
	);
};

export default DiscountsHeader;

const styles = StyleSheet.create({
	root: { backgroundColor: "#0843F5" },
	pressable: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#fff",
		// borderColor: "#ff0000",
		// borderWidth: 1,
		padding: 20,
	},
	title: {
		alignItems: "center",
		marginLeft: -28,
		flex: 1,
		//backgroundColor: "#ff0",
	},
	text: {
		fontWeight: "500",
		fontSize: 20,
		lineHeight: 26,
		fontFamily: "DmSans",
	},
});
